import { render } from "./SRUseStatusButton.vue?vue&type=template&id=c0b2e80e&scoped=true"
import script from "./SRUseStatusButton.vue?vue&type=script&lang=js"
export * from "./SRUseStatusButton.vue?vue&type=script&lang=js"

import "./SRUseStatusButton.vue?vue&type=style&index=0&id=c0b2e80e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c0b2e80e"

export default script